import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { dictionary } from "../../utils/dictionary";
import CampaignsTabContent from "./CampaignsTabContent";
import PerformanceCreativosTab from "./performance/PerformanceCreativosTab";

type SubTab = "overview" | "performance";

interface CampaignsViewProps {
  dateStart?: string;
  dateEnd?: string;
  refreshKey?: number;
  selectedAdAccount?: string | null;
}

const DEFAULT_START = () => {
  const d = new Date();
  d.setDate(d.getDate() - 30);
  return formatDate(d);
};

const DEFAULT_END = () => formatDate(new Date());

const formatDate = (d: Date) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const CampaignsView = ({
  dateStart,
  dateEnd,
  refreshKey,
  selectedAdAccount,
}: CampaignsViewProps) => {
  const { language } = useAuth();
  const [subTab, setSubTab] = useState<SubTab>("overview");

  const effectiveStart = dateStart ?? DEFAULT_START();
  const effectiveEnd = dateEnd ?? DEFAULT_END();

  return (
    <div className="w-full">
      {/* Sub-tabs */}
      <div className="flex items-center gap-1 px-1 mb-4 border-b border-gray-200">
        <SubTabButton active={subTab === "overview"} onClick={() => setSubTab("overview")}>
          {dictionary["campaigns-subtab-overview"]?.[language] ?? "Vista general"}
        </SubTabButton>
        <SubTabButton active={subTab === "performance"} onClick={() => setSubTab("performance")}>
          {dictionary["campaigns-subtab-performance"]?.[language] ?? "Performance de creativos"}
        </SubTabButton>
      </div>

      {subTab === "overview" && (
        <CampaignsTabContent
          dateStart={dateStart}
          dateEnd={dateEnd}
          refreshKey={refreshKey}
          selectedAdAccount={selectedAdAccount}
        />
      )}

      {subTab === "performance" && (
        <PerformanceCreativosTab
          selectedAdAccount={selectedAdAccount ?? null}
          dateStart={effectiveStart}
          dateEnd={effectiveEnd}
          refreshKey={refreshKey}
        />
      )}
    </div>
  );
};

const SubTabButton = ({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
      active
        ? "border-fluxi text-fluxi"
        : "border-transparent text-gray-500 hover:text-gray-700"
    }`}
  >
    {children}
  </button>
);

export default CampaignsView;
